<template>
  <div>
    <ButtonEdit
      :text="$gettext('Edit')"
      v-if="isCourseAdmin"
      @click="isEdit = !isEdit"
      class="d-flex justify-end"
    />
    <v-card class="pa-md-6 pa-4 form-group-custom" v-if="isEdit">
      <template>
        <TiptapEditor
          :value="content"
          name="content"
          @setInputEditor="setInputEditor"
        />
        <div class="mt-3">
          <v-btn
            small
            @click="edit"
            class="font-weight-bold elevation-0 text-none subtitle-1 mr-3 px-4 py-5"
          >
            <translate>Cancel</translate>
          </v-btn>
          <v-btn
            small
            type="submit"
            color="primary"
            @click="onSubmit"
            class="font-weight-bold elevation-0 text-none subtitle-1 px-4 py-5"
          >
            <translate>Save</translate>
          </v-btn>
        </div>
      </template>
    </v-card>

    <v-card
      class="pa-md-6 pa-4 form-group-custom"
      v-if="(content && (content && content !== '<p></p>')) && !isEdit"
    >
      <template>
        <div class="d-flex justify-end align-center">
          <div class="actionSection mb-4"></div>
        </div>
        <ContentHTML :content="content" :key="isEdit"/>
      </template>
    </v-card>
    <v-card v-else-if="!isEdit" class="pa-md-6 pa-4">
      {{$gettext("The information has not been updated.")}}
    </v-card>
  </div>
</template>

<script>
import ButtonEdit from "@/components/Buttons/ButtonEdit";
import TiptapEditor from "@/components/Tiptap/TiptapEditor";
import ContentHTML from "@/components/ContentHTML";
export default {
  name: "PresentationAboutCourse",

  props: {
    isCourseAdmin: { type: Boolean, default: false }
  },
  components: {
    TiptapEditor,
    ButtonEdit,
    ContentHTML
  },
  data() {
    return {
      isEdit: false,
      content: ""
    };
  },
  computed: {
    course() {
      return this.$store.state.golfcourse.courseDetail;
    }
  },
  methods: {
    edit() {
      this.isEdit = !this.isEdit;
      if(!this.isEdit) {
        this.content = this.course.content
      }
    },
    setInputEditor(data) {
      this.content = data.val;
    },
    async onSubmit() {
      const data = {
        id: this.course.id,
        content: this.content
      };
      const result = await this.$store.dispatch("updateCourse", data);
      if (result.error) {
        this.$toast.alert(result.error.message);
      } else {
        this.$toast.success(this.$gettext(`Update success`));
        await this.$store.dispatch(
          "getDetailCourse",
          this.$route.params.namegolf
        );
        this.edit();
      }
    }
  },
  watch: {
    course: {
      immediate: true,
      handler(val) {
        this.content = val.content;
      }
    }
  },
};
</script>
